/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
/* eslint-disable new-cap */
/* eslint-disable react/prop-types */
import React, { useContext, useState } from "react";
import Box from "@mui/material/Box";
import * as Sentry from "@sentry/react";
import moment from "moment";
import ArticleIcon from "@mui/icons-material/Article";
import styles from "./ExportButton.styles";
import Button from "../../../../../components/Layout/Button/NewButton";
import { SERVICES } from "../../../../../components/Layout/Services";
import { post } from "../../../../../components/Layout/ApiHandler/apihandler";
import { ToastAlertContext } from "../../../../../Config/Providers/ToastAlert";
import { AlertStatus } from "../../../Components/constant";

function ExportButton({ initialAdvanceFormValue }) {
  const toast = useContext(ToastAlertContext);

  const handleExport = async () => {
    try {
      if (
        !initialAdvanceFormValue?.startDate ||
        !initialAdvanceFormValue?.endDate
      ) {
        throw new Error("Invalid date values");
      }

      const formattedStartDate = moment(
        initialAdvanceFormValue.startDate,
      ).format("YYYY-MM-DD");
      const formattedEndDate = moment(initialAdvanceFormValue.endDate).format(
        "YYYY-MM-DD",
      );

      const xAuthToken = localStorage.getItem("X-Auth-Token");

      const submitResponse = await fetch(
        `${SERVICES.GENERATE_CSV}?from=${formattedStartDate}&to=${formattedEndDate}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Auth-Token": xAuthToken,
          },
        },
      );

      if (!submitResponse.ok) {
        throw new Error("Failed to generate csv");
      }

      toast.show("CSV downloaded successfully!", AlertStatus.SUCCESS);
    } catch (error) {
      toast.show(error.message || "Error generating", AlertStatus.ERROR);
    }
  };

  return (
    <Box style={{ ...styles.dropdown }}>
      <Box>
        {" "}
        <Button
          variant="outlined"
          style={{
            ...styles.leftSideBtn,
            color: "#00ADF8",
            border: "1px solid #00ADF8",
          }}
          onClick={handleExport}
          label="Generate CSV"
          startIcon={
            <ArticleIcon
              sx={{
                fontSize: "18px",
                fontWeight: "100",
              }}
            />
          }
        />
      </Box>
    </Box>
  );
}

export default ExportButton;
